const faqSchema = data => {
  if (!data || Object.keys(data).length === 0 || data.count === 0) return null;
  const finalList = data.filter(item => item.question && item.answer).map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer
    }
  }));
  return {
    mainEntity: finalList
  };
};

export default faqSchema;